export default "/images/e03751576b6fb1c4a623b22a4529f86a.avif";